import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import ScrollBar from 'client/widgets/ui/scroll-bar';

const Wrap = styled.div
  .withConfig({
    shouldForwardProp: (props) => {
      return !['position'].includes(props);
    },
  })
  .attrs((props) => ({
    className: props.position,
  }))`
  position: absolute;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  z-index: 10;

  padding: 5px 0;
  width: 100%;
  font-size: var(--fs-base);

  &.bottom {
    top: 100%;
    left: 0;
  }

  &.bottomRight {
    top: 100%;
    right: 0;
  }

  &.top {
    bottom: 100%;
  }

  &.topRight {
    bottom: 100%;
    right: 0;
  }

  &.left {
    top: 0;
    right: 100%;
    width: 150px;
  }

  &.right {
    top: 0;
    right: 100%;
    width: 150px;
  }

  .item {
    display: flex;
    //width: 100%;
    align-items: center;
    padding: 0 15px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    color: ${(props) => props.theme.color.grayLight};
    overflow: hidden;

    &:hover {
      color: ${(props) => props.theme.color.gray};
      background-color: ${(props) => props.theme.color.grayLighter};
    }
  }

  &.center .item {
    justify-content: center;
  }
  ._dark & {
    background-color: #3e454d;
    color: #c3c3c3;
    .item {
      background-color: #3e454d;
      height: 40px;
      font-size: var(--fs-base);
      &:hover {
        color: #fff;
        background-color: #454d56;
      }
      &.active {
        color: #fff;
      }
    }
  }
`;

const PopupSelect = observer(
  React.forwardRef((props, ref) => {
    let {
      position,
      onClose,
      onSelectItem,
      children,
      className,
      style,
      enableScroll = false,
      maxHeight = '220px',
    } = props;

    const _onSelectItem = (e) => {
      let { key } = e.currentTarget.dataset;
      onSelectItem && onSelectItem(key);
      _onClose();
    };

    const _onClose = () => {
      onClose && onClose();
    };

    const renderChildren = () => {
      if (enableScroll) {
        return <ScrollBar style={{ maxHeight }}>{children}</ScrollBar>;
      }
      return children;
    };

    return (
      <Wrap
        position={position}
        className={className + ' _popup_select'}
        style={style}
        ref={ref}
      >
        {renderChildren()}
      </Wrap>
    );
  }),
);

export default PopupSelect;
